import { Table } from "@material-ui/core";
import React from "react";

export const TableContent = ({ children }) => {
  return (
    <Table
      className="table"
      style={{
        marginTop: "0px",
        marginBottom: "0px",
        padding: "0px",
        borderCollapse: "collapse",
        borderSpacing: "0px",
        width: "100%",
      }}
    >
      {children}
    </Table>
  );
};
